








































































import { FormProdutoSimples, ProdutoProjection } from '@/models'
import type { FormProduto } from '@/models'
import { FindProdutoUseCase } from '@/usecases'
import { Vue, Component, Prop } from 'vue-property-decorator'

@Component
export default class DialogoDeProdutosRelacionados extends Vue {
	@Prop({ required: true }) produto!: FormProduto
	mostra = false
	tab = 0
	produtosSimilares: FormProdutoSimples[] = []
	produtosComplementares: ProdutoProjection[] = []
	carregandoSimilares = false
	carregandoComplementares = false
	findProdutoUseCase = new FindProdutoUseCase()

	async mostrar(){
		this.produtosComplementares = []
		this.produtosSimilares = []
		this.mostra = true
		await this.buscarProdutosRelacionados()
	}

	async buscarProdutosRelacionados() {
		this.carregandoSimilares = true
		this.carregandoComplementares = true
		try {
			const produtoId = (this.produto as any).id
			this.produtosSimilares = await this.findProdutoUseCase.findProdutosSimilaresByIds({produtosIds: [produtoId]})
			this.produtosComplementares = await this.findProdutoUseCase.findProdutosComplementaresByIds({produtosIds: [produtoId]})
		} catch {
			this.produtosSimilares = []
			this.produtosComplementares = []
		} finally {
			this.carregandoSimilares = false
			this.carregandoComplementares = false
		}
	}
}
